module.exports = __webpack_public_path__ + "img/larm-rmah-AEaTUnvneik-unsplash-cropped-compressed.de448648.webp";